var initialState = {
    byId: {},
    allIds: []
};

export default (state = initialState, action) => {
    if (action.payload?.entities?.paymentType) {
        state = {
            ...state,
            byId: {
                ...state.byId,
                ...action.payload.entities.paymentType
            }
        }
    }
    switch (action.type) {
        default:
            return state;
    }
}
